<template>
  <div>
    <div v-if="getcommandeAchatARapprocher.length > 0">
      <v-client-table :data="getcommandeAchatARapprocher"
                      class='mgt-10px column is-12 is-paddingless'
                      :columns="columns"
                      :options="options">
        <template slot="code" slot-scope="{ row }">
          <router-link-blank v-if="getRoute(row)" v-bind="getRoute(row)"/>
        </template>
        <template slot="datePremierAffichage" slot-scope="props">
          {{ getDate(props.row) }}
        </template>
        <template slot="dateDebut" slot-scope="props">
          {{ props.row.echeanciers[0].dateDebut | formatDate }}
        </template>
        <template slot="dateFin" slot-scope="props">
          {{ props.row.echeanciers[0].dateFin | formatDate }}
        </template>
        <template slot="montantHt" slot-scope="props">
          <div class="has-text-right">
            {{ props.row.montantHt | formatDevise }}
          </div>
        </template>
        <template slot="montantRestant" slot-scope="props">
          <div class="has-text-right">
            <b-field position="is-right">
              <span>{{ calculeResteAPayer(props.row) | formatDevise }}</span>
              <div @click="assignAmount(props.row)" v-if="!isVisualisation">
                <b-icon icon="arrow-expand-right" type="is-primary"
                        class="mgl-10px is-cursor-pointer"></b-icon>
              </div>
            </b-field>
          </div>
        </template>
        <template slot="solde" slot-scope="props">
          <div class="has-text-right">
            {{ Math.abs(calculeResteAPayer(props.row) - props.row.montantAffecter) | formatDevise }}
          </div>
        </template>
        <template slot="montantAffecter" slot-scope="props">
          <input-currency :peutEtreNegatif="true"
                          v-model="props.row.montantAffecter" v-if="!isVisualisation"
                          @input="checkMontant(props.row)"></input-currency>
          <div v-else class="has-text-right"> {{ props.row.montantAffecter | formatDevise}}</div>
        </template>
      </v-client-table>
    </div>
    <div class="card" v-else>
      <div class="card-content">
        <div class="columns">
          <div class="column is-12">
            <p class="has-text-centered title is-size-5"
               v-if="facture.intervenants.length > 0 && facture.intervenants[0].tiersId">
              {{ isVisualisation ?
              $t('rapprochementAchat.error.noCommandeAchatRapprocher',
              { fournisseur: facture.intervenants[0].nomCommercial }) :
              $t('rapprochementAchat.error.noCommandeAchatARapprocher',
              { fournisseur: facture.intervenants[0].nomCommercial }) }}
            </p>
            <p class="has-text-centered title is-size-5" v-else>
              {{ $t('rapprochementAchat.error.needFournisseur') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputCurrency from '@/components/general/inputCurrency';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import formatDate from '@/services/general/formatDate';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import {
  LOCATION,
  MODULE_BAIL,
  MODULE_ACHAT,
  SOUS_TYPE_BON_RECEPTION,
} from '@/configuration/devisConf';
import moment from 'moment';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';

export default {
  props: {
    commandeAchatARapprocher: {
      type: Array,
      required: true,
    },
    facture: {
      type: Object,
      required: true,
    },
    isVisualisation: {
      type: Boolean,
      required: false,
      default: false,
    },
    moduleType: {
      type: String,
      required: true,
    },
  },
  components: {
    inputCurrency,
    routerLinkBlank,
  },
  computed: {
    getcommandeAchatARapprocher() {
      return this.commandeAchatARapprocher.filter((commandeAchat) => {
        return this.calculeResteAPayer(commandeAchat) !== 0;
      });
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('rapprochementAchat.tab.reference'),
          datePremierAffichage: this.$t('rapprochementAchat.tab.dateEcheance'),
          dateDebut: this.$t('rapprochementAchat.tab.dateDebut'),
          dateFin: this.$t('rapprochementAchat.tab.dateFin'),
          montantHt: this.$t('rapprochementAchat.tab.montantHt'),
          montantRestant: this.$t('rapprochementAchat.tab.montantRestant'),
          montantAffecter: this.isVisualisation ? this.$t('rapprochementAchat.tab.montantAffecter') : this.$t('rapprochementAchat.tab.montantAAffecter'),
          solde: this.$t('rapprochementAchat.tab.solde'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {},
        rowClassCallback: ((row) => {
          return row.isIntoActualSearch ? '' : 'has-background-select';
        }),
        sortable: this.isVisualisation ? ['code', 'datePremierAffichage', 'montantHt', 'montantAffecter'] : [],
      };
    },
    columns() {
      return ['code', 'datePremierAffichage', 'dateDebut', 'dateFin', 'montantHt', 'montantRestant', 'montantAffecter', 'solde'];
    },
  },
  methods: {
    getDate(row) {
      switch (this.moduleType) {
        case MODULE_TLPE:
        case MODULE_ACHAT:
          return formatDate(row.dateDevisCommande);
        case MODULE_BAIL:
          return formatDate(row.datePremierAffichage);
        default:
          return '';
      }
    },
    getRoute(row) {
      switch (this.moduleType) {
        case MODULE_TLPE:
          return {
            to: {
              name: 'c.gabed.commande_tlpe',
              params: {
                id: row.id,
              },
            },
            message: row.code,
          };
        case MODULE_BAIL:
          return {
            to: {
              name: 'c.baux.contrat',
              params: {
                id: row.referenceExterne,
              },
            },
            message: row.codeDossier,
          };
        case MODULE_ACHAT:
        {
          let name = 'c.achat.commandes';
          if (row.sousType === SOUS_TYPE_BON_RECEPTION) {
            name = 'c.achat.bon_reception';
          }
          return {
            to: {
              name: name,
              params: {
                id: row.id,
              },
            },
            message: row.code,
          };
        }
        default:
          return null;
      }
    },
    assignAmount(commande) {
      const montant = Number(this.calculeResteAPayer(commande).toFixed(2));
      const commandeFind = this.getcommandeAchatARapprocher.find((commandeAchat) => {
        return commandeAchat.id === commande.id;
      });
      if (commandeFind) {
        this.$set(commandeFind, 'montantAffecter', montant);
        const ligneCommandeLocation = this.facture.lignesCommande.find((ligne) => {
          return ligne.typeProduit === LOCATION;
        });
        if (!ligneCommandeLocation) return;
        let dateDebut = null;
        let dateFin = null;
        this.getcommandeAchatARapprocher
          .filter((commandeARapprocher) => {
            return commandeARapprocher.montantAffecter > 0;
          })
          .forEach((commandeAchat) => {
            if (!dateDebut
              || moment(commandeAchat.echeanciers[0].dateDebut).isBefore(moment(dateDebut))) {
              dateDebut = moment(commandeAchat.echeanciers[0].dateDebut).toDate();
            }
            if (!dateFin
              || moment(commandeAchat.echeanciers[0].dateDebut).isAfter(moment(dateFin))) {
              dateFin = moment(commandeAchat.echeanciers[0].dateFin).toDate();
            }
          });
        ligneCommandeLocation.dateDebut = dateDebut;
        ligneCommandeLocation.dateFin = dateFin;
      }
    },
    checkMontant(commande) { // si null ou superieur aux montants on régule
      const commandeFind = this.getcommandeAchatARapprocher.find((commandeAchat) => {
        return commandeAchat.id === commande.id;
      });
      if (!commande.montantAffecter) {
        this.$set(commandeFind, 'montantAffecter', 0);
        return;
      }
      const resteAPayer = this.calculeResteAPayer(commande);
      if (resteAPayer > 0
       && commande.montantAffecter > resteAPayer) {
        const montant = Number(resteAPayer.toFixed(2));
        this.$set(commandeFind, 'montantAffecter', montant);
      } else if (resteAPayer < 0
       && commande.montantAffecter < resteAPayer) {
        const montant = Number(resteAPayer.toFixed(2));
        this.$set(commandeFind, 'montantAffecter', montant);
      } else this.$set(commandeFind, 'montantAffecter', commande.montantAffecter);
    },
    calculeResteAPayer(commande) {
      let montant = 0;
      commande.echeanciers.forEach(e => {
        montant += e.echeancierLignes
          .filter(l => !l.facturationFaite || l.factureId === this.$route.params.id)
          .map(l => l.montant)
          .reduce((a, b) => a + b, 0);
      });
      return montant;
    },

  },
};
</script>
